/**
 * Instant, client-side, title-only product search. Replaces Shopify's
 * native predictive search entirely — no fetch, no results page, no
 * collections/pages/articles, just product titles filtered from a JSON
 * index rendered once in the page (see snippets/simple-search-data.liquid).
 */
function loadProducts() {
  const dataEl = document.getElementById('simple-search-data');
  if (!dataEl) return [];

  try {
    return JSON.parse(dataEl.textContent);
  } catch (error) {
    console.warn('[simple-search] failed to parse product data:', error);
    return [];
  }
}

function filterProducts(products, query) {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return [];
  return products.filter((product) => product.title.toLowerCase().includes(normalized));
}

function renderResults(container, results) {
  container.innerHTML = '';

  if (results.length === 0) {
    const empty = document.createElement('p');
    empty.className = 'simple-search__empty';
    empty.textContent = 'No products found';
    container.appendChild(empty);
    return;
  }

  const list = document.createElement('ul');
  list.className = 'simple-search__list';

  results.forEach((product) => {
    const item = document.createElement('li');
    item.className = 'simple-search__item';

    const link = document.createElement('a');
    link.href = product.url;
    link.className = 'simple-search__link';

    if (product.image) {
      const img = document.createElement('img');
      img.src = product.image;
      img.alt = '';
      img.loading = 'lazy';
      img.className = 'simple-search__image';
      link.appendChild(img);
    }

    const title = document.createElement('span');
    title.className = 'simple-search__title';
    title.textContent = product.title;
    link.appendChild(title);

    item.appendChild(link);
    list.appendChild(item);
  });

  container.innerHTML = '';
  container.appendChild(list);
}

function initSimpleSearch() {
  const input = document.getElementById('cmdk-input');
  const container = document.getElementById('simple-search-results');
  const resetButton = document.querySelector('.predictive-search__reset-button');
  if (!input || !container) return;

  const products = loadProducts();

  input.addEventListener('input', () => {
    const results = filterProducts(products, input.value);
    renderResults(container, results);
    if (resetButton) resetButton.hidden = input.value.trim() === '';
  });

  resetButton?.addEventListener('click', () => {
    input.value = '';
    container.innerHTML = '';
    resetButton.hidden = true;
    input.focus();
  });

  // No results page — instant dropdown only, so a full-page submit should
  // never happen (e.g. pressing Enter).
  input.closest('form')?.addEventListener('submit', (event) => {
    event.preventDefault();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSimpleSearch);
} else {
  initSimpleSearch();
}
